module.exports = __webpack_public_path__ + "img/equipos-moviles-img-6.caa4362b.jpg";